import { LOCATION_TYPES } from "@circle-react/components/Events/helpers/constants";
import { dateIsPast } from "@circle-react/helpers/dateTimeHelpers";
import { dateLongMonthYearString } from "@circle-react/helpers/dateTimeHelpers/getLocalizedDate";
import type { Event } from "@circle-react/types/Event";

export const getEventsByMonth = (events: Event[] = [], activeSort: string) => {
  const eventsByMonth = new Map<string, Event[]>();

  const sortEvents = (a: Event, b: Event) => {
    try {
      const date1 = new Date(a.event_setting_attributes?.starts_at);
      const date2 = new Date(b.event_setting_attributes?.starts_at);

      return activeSort === "desc"
        ? date2.getTime() - date1.getTime()
        : date1.getTime() - date2.getTime();
    } catch (error) {
      if (error instanceof Error) {
        console.error(
          `Event ListView - error sorting events - ${error.message}`,
        );
      }
      return 0;
    }
  };

  events.sort(sortEvents).forEach(event => {
    const longMonthYearString = dateLongMonthYearString(
      event.event_setting_attributes?.starts_at,
      event.event_setting_attributes?.time_zone,
    );
    if (!eventsByMonth.has(longMonthYearString)) {
      eventsByMonth.set(longMonthYearString, []);
    }
    eventsByMonth.get(longMonthYearString)?.push(event);
  });

  return eventsByMonth;
};

export const filterEvents = (
  events: Event[] = [],
  isUpcomingEvents: boolean,
) => {
  const liveEvents: Event[] = [];
  const filteredEvents: Event[] = [];

  events.forEach(event => {
    const {
      event_setting_attributes: {
        starts_at: startsAt,
        ends_at: endsAt,
        location_type: locationType,
        live_stream_room_setting_attributes: roomSetting,
      },
    } = event;
    const isFinished = dateIsPast(endsAt);
    const isStarted = dateIsPast(startsAt);
    if (isUpcomingEvents && isStarted && !isFinished) {
      const isLiveLocation =
        locationType == LOCATION_TYPES.LIVE_STREAM ||
        locationType == LOCATION_TYPES.LIVE_ROOM;

      const isActiveEvent = roomSetting?.stream_status == "active";

      if (!isLiveLocation || (isLiveLocation && isActiveEvent)) {
        liveEvents.push(event);
      } else {
        filteredEvents.push(event);
      }
    } else {
      filteredEvents.push(event);
    }
  });

  return { liveEvents, filteredEvents };
};
